import { UserState } from '@/types/types';
import { Ability, AbilityBuilder, AbilityClass } from '@casl/ability';
import { Action, Subject } from '@/types/enums';

export type AppAbility = Ability<[Action, Subject]>;
export const AppAbility = Ability as AbilityClass<AppAbility>;

export const ability = new Ability();
if (process.env.NODE_ENV !== 'production') {
  // expose ability to play around with it in devtools
  (window as any).ability = ability;
}

export const defineRulesFor = (user: UserState) => {
  const { can, cannot, rules } = new AbilityBuilder(AppAbility);

  cannot(Action.READ, Subject.all); /* Start without full read permission */

  if (user?.siteMetadata?.featureFlags) {
    const featureFlags = user.siteMetadata.featureFlags;

    if (featureFlags.dtcEnabled === true) {
      can([Action.READ, Action.WRITE], Subject.table_dtc);
    }

    if (featureFlags.stockNumberEnabled === true) {
      can([Action.READ, Action.WRITE], Subject.stock_number);
    }
    if (featureFlags.sellerIdEnabled === true) {
      can([Action.READ, Action.WRITE], Subject.seller_id);
    }
    if (featureFlags.vehicleBatteryEnabled === true) {
      can([Action.READ, Action.WRITE], Subject.vehicle_battery);
    }
    if (featureFlags.workOrderEnabled === true) {
      can([Action.READ, Action.WRITE], Subject.work_order);
    }
    if (featureFlags.geofenceEnabled === true) {
      can([Action.READ, Action.WRITE], Subject.geofence);
    }
    if (
      featureFlags.dtcEnabled === true &&
      featureFlags.dtcDisclaimerEnabled === true
    ) {
      can([Action.READ, Action.WRITE], Subject.disclaimer);
    }
    if (featureFlags.markAsFound === true) {
      can([Action.READ, Action.WRITE], Subject.mark_as_found);
    }
  }
  return rules;
};

export const defineAbilityFor = (user: UserState) =>
  new Ability(defineRulesFor(user));
